import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

const routeMapping = {

	'/collection/:id/details': (location) => {
		return '/collection';
	},

	'/collection/:id/edit': (location) => {
		// extract the ID from the current path
		const match = location?.pathname.match(/\/collection\/([^/]+)/);
		const qrId = match ? match[1] : null;

		return qrId ? `/collection/${qrId}/details` : -1;
	},

  '/collection/:id/design': (location) => {
    return
	},

	// Add other special routes here if needed:

};

export const useBack = (defaultPathFallback = null) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams,] = useSearchParams();

	const goBack = () => {
		const currentPath = location.pathname;
		let targetPath = null;

		if (searchParams.has('ref')) {
			targetPath = decodeURI(searchParams.get('ref'));
		}

		for (const routePattern in routeMapping) {
      const parts = routePattern.split(':id');
			if (currentPath.startsWith(parts[0]) && currentPath.includes(parts[1])) {
				targetPath = parts[1].includes('details') ? '/collection' : -1;

				break;
			}
		}

		// Check if referrer is from external origin (e.g., Stripe)
		const currentOrigin = window.location.origin;
		const referrer = document.referrer;
		const isExternalReferrer = referrer && !referrer.startsWith(currentOrigin);

		if (targetPath) {
      const options = targetPath === -1 ? {} : { replace: true };

			navigate(targetPath, options);
		} else if (isExternalReferrer) {
			// If we came from external site, go to fallback or home instead of back
			navigate(defaultPathFallback || '/home', { replace: true });
		} else if (defaultPathFallback) {
			navigate(defaultPathFallback, { replace: true });
		} else {
			navigate(-1);
		}
	};

	return goBack;
};